import Resources from '../../helpers/resources';
import * as actionTypes from './course-assign-types';
import { isDefined } from '../../helpers/utils';
import {
  getInstructionHubAssignmentsConfig,
  markInstructionHubAssignmentsForLocalTesting,
  markInstructionHubStudentResultForLocalTesting
} from '../../helpers/instruction-hub/instruction-hub-assignments';

export const getClassrooms = (productId) => async (dispatch) => {
  let response = null;
  try {
    response = await Resources.getClassrooms
      .get({ productId })
      .withParams()
      .send();

    if (response && response.data) {
      dispatch({
        type: actionTypes.CLASSROOMS_ACQUIRED,
        payload: response.data
      });
    } else {
      dispatch({
        type: actionTypes.SHOW_TOAST,
        isToastVisible: true,
        message: response && response.message
      });
    }
  } catch (err) {
    dispatch({
      type: actionTypes.ERROR_DETECTED,
      payload: err
    });
    throw err;
  }
};

export const restrictActivities = (isRestricted, classId, groupId) => async (
  dispatch
) => {
  let response = null;
  try {
    dispatch({ type: actionTypes.RESTRICT_ACCESS_REQUEST });
    response = await Resources.restrictActivities
      .put({ isRestricted, classId, groupId })
      .withBody({})
      .send();
    if (response.status === 200) {
      dispatch({
        type: actionTypes.RESTRICT_ACCESS_SUCCESS,
        payload: isRestricted
      });
      return response;
    }
    dispatch({ type: actionTypes.RESTRICT_ACCESS_FAILURE });
    return response;
  } catch (err) {
    dispatch({ type: actionTypes.ERROR_DETECTED, payload: err });
    throw err;
  }
};

export const getTopics = (classId, groupId) => async (dispatch) => {
  let response = null;

  try {
    if (classId && groupId) {
      dispatch({ type: actionTypes.TOPICS_ACQUIRED_REQUEST });
      response = await Resources.getAssignments
        .get({ classroomId: classId, groupId })
        .send();

      if (response && response.status === 200) {
        const instructionHubConfig = getInstructionHubAssignmentsConfig();
        const payload = markInstructionHubAssignmentsForLocalTesting(
          response.data,
          instructionHubConfig
        );
        dispatch({
          type: actionTypes.TOPICS_ACQUIRED_SUCCESS,
          payload,
          instructionHubConfig
        });
        return payload;
      }
      dispatch({ type: actionTypes.TOPICS_ACQUIRED_FAILURE });
      return response;
    }
    return [];
  } catch (err) {
    dispatch({ type: actionTypes.ERROR_DETECTED, payload: err });
    throw err;
  }
};

export const getTopicsFromCourse = (courseId) => async (dispatch) => {
  let response = null;

  try {
    if (courseId && courseId !== -1) {
      dispatch({ type: actionTypes.COURSE_TOPICS_ACQUIRED_REQUEST });
      response = await Resources.getcourseTopics.get({ courseId }).send();

      if (response && response.status === 200) {
        dispatch({
          type: actionTypes.COURSE_TOPICS_ACQUIRED_SUCCESS,
          payload: response.data
        });
        return response.data;
      }
    }
    dispatch({ type: actionTypes.COURSE_TOPICS_ACQUIRED_FAILURE });
    return response;
  } catch (err) {
    dispatch({ type: actionTypes.ERROR_DETECTED, payload: err });
    throw err;
  }
};

export const getActivityReportById = (
  classroomId,
  encryptedUserProfileId,
  activityId,
  taskType
) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST });
    const response = await Resources.getStudentActivitiesByActivityId
      .post()
      .withBody({ classroomId, encryptedUserProfileId, activityId, taskType })
      .send();

    if (response && response.status === 200) {
      dispatch({
        type: actionTypes.STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS,
        payload: response.data
      });
      return response.data;
    }
    return null;
  } catch (err) {
    dispatch({ type: actionTypes.ERROR_DETECTED, payload: err });
    throw err;
  }
};

export function updateFiltersActionCreator(data) {
  /* eslint-disable indent */
  return {
    type: actionTypes.UPDATE_ASSIGNMENT_FILTERS,
    payload: {
      dateFilter: isDefined(data.dateData?.dateRange)
        ? {
            dateRange: data.dateData.dateRange
          }
        : undefined,
      rangeData: data.rangeData,
      dropdownValue: data.dropdownValue
    }
  };
  /* eslint-enable indent */
}

export const getStudentResultById = (
  classroomId,
  encryptedUserProfileId
) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.STUDENT_RESULT_REQUEST });
    const response = await Resources.getStudentResult
      .post()
      .withBody({ classroomId, encryptedUserProfileId })
      .send();

    if (response && response.status === 200) {
      const payload = markInstructionHubStudentResultForLocalTesting(
        response.data
      );
      dispatch({
        type: actionTypes.STUDENT_RESULT_SUCCESS,
        payload
      });
      return payload;
    }
    return null;
  } catch (err) {
    dispatch({ type: actionTypes.ERROR_DETECTED, payload: err });
    throw err;
  }
};



// WEBPACK FOOTER //
// ./containers/course-assign/course-assign-actions.js